import "../../assets/css/eventPage.css";
import HeaderNewWebsite from "../header/HeaderNewWebsite";
import "../../assets/css/style.css";
import "../../assets/css/header.css";

import React, { useEffect, useState } from 'react';
import { listEvenement, listTheme } from '../../../admin/request/Request';
import FooterSection from "../footer/FooterSection";
import { useFormik } from 'formik';
import icon_calendar from "../../assets/img/event-calendar-icon.png";
import defaultLang, { englishLang } from "../../config";


export default function EventPage() {
  const [entity, setEntity] = useState("");
  const [date, setDate] = useState("");
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [current, setCurrent] = useState(1);
  const [info, setInfo] = useState({});
  const [hasMore, setHasMore] = useState(true);
  const [themes, setThemes] = useState([]);
  const [localStorageChange, setLocalStorageChange] = useState(JSON.parse(localStorage.getItem('lang')) || defaultLang);

  const loadEvents = async (page, entityFilter = entity, dateFilter = date) => {
    setLoading(true);
    try {
      const response = await listEvenement(page, 6, dateFilter, '', '', entityFilter, 1);
      if (response.status === 200) {
        if (page === 1) {
          setEvents(Array.isArray(response.data.data) ? response.data.data : []);
        } else {
          setEvents(prev => [...prev, ...(Array.isArray(response.data.data) ? response.data.data : [])]);
        }
        setInfo(response.data);
        setCurrent(page);
        setHasMore(response.data.currentPage < response.data.totalPages);
      }
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  const lesThemes = async () => {
    try {
      const reponse = await listTheme();
      if (reponse.status === 200) {
        setThemes(reponse.data);
      }
    } catch (_) {}
  };

  useEffect(() => {
    loadEvents(1);
    lesThemes();
  }, []);
  useEffect(() => {
    loadEvents(1, entity, date);
  }, [entity, date]);
  function formatDateRange(datePublication, dateFin, lang = 'fr') {
    const mois = [
      "janvier", "février", "mars", "avril", "mai", "juin",
      "juillet", "août", "septembre", "octobre", "novembre", "décembre"
    ];
    const month = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];

    const pub = new Date(datePublication);
    const fin = new Date(dateFin);

    const jourPub = pub.getDate();
    let moisPub = mois[pub.getMonth()];
    const anneePub = pub.getFullYear();

    const jourFin = fin.getDate();
    let moisFin = mois[fin.getMonth()];
    const anneeFin = fin.getFullYear();
    if (lang === englishLang.code) {
      moisPub = month[pub.getMonth()];
      moisFin = month[fin.getMonth()];
    }
    if (
      jourPub === jourFin &&
      moisPub === moisFin &&
      anneePub === anneeFin
    ) {
      return `${jourFin} ${moisFin} ${anneeFin}`;
    }

    if (moisPub === moisFin && anneePub === anneeFin) {
      return `${jourPub} - ${jourFin} ${moisFin} ${anneePub}`;
    }

    return `${jourPub} ${moisPub} ${anneePub} - ${jourFin} ${moisFin} ${anneeFin}`;
  }

  if (loading) return null;
  if (error && events.length > 0) {
    return <div className="alert alert-danger">Erreur: {error.message}</div>;
  }
  let themeList = [];
  for (let i = 0; i < themes.length; i++) {
    themeList.push(<option value={themes[i].idtheme}>{themes[i].description}</option>);
  }


  return (
    <>
      <header>
        <HeaderNewWebsite />
      </header>
      <section className="main-section event-page">
        <div className="container-fluid">
          <div className="titre-actus">
            <h1 className="mb-3">
              {localStorageChange.code === englishLang.code ? "Upcoming Events" : "Événements à venir"}
            </h1>
          </div>

          <div className="filters mb-4">
            <div className="filters-flex">
              <select
                className="engagement-select filter-item"
                name="entity"
                id="entity"
                value={entity}
                onChange={e => setEntity(e.target.value)}
              >
                <option value="">
                  {localStorageChange.code === englishLang.code ? "All" : "Tous"}
                </option>
                {themeList}
              </select>
              <div className="date-filter-wrapper filter-item">
                <span className="date-filter-label" aria-hidden="true">
                  <span>
                    {date
                      ? new Date(date + 'T00:00:00').toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' })
                      : 'jj/mm/aaaa'
                    }
                  </span>
                  <img src={icon_calendar} alt="" width="20" height="20" />
                </span>
                <input
                  type="date"
                  className="engagement-date"
                  id="publication-date"
                  name="date"
                  value={date}
                  onChange={e => setDate(e.target.value)}
                />
              </div>
            </div>
          </div>

          <div className="row g-4">
            {events.slice(0, current * 6).map((event) => (
              <div className="col-12 col-md-6 col-lg-4 col-xl-4 d-flex" key={event.idactualite}>
                <div className="event-card flex-fill">
                  <div className="event-card-header">
                    {event.media.map((it, index) => {
                      if (it.genremedia.idgenremedia === 3) {
                        return <img key={"imagelogo" + index} src={it.lien} alt="event background" />
                      }
                    })}
                  </div>
                  <div className="event-card-footer">
                    <div className="info">
                      <div className="event-title">
                        <h3>{event.titre}</h3>
                      </div>
                      <div className="event-location">{event.ville}</div>
                      <div className="event-date">
                        <span className="event-date-icon">
                          <img src={icon_calendar} alt="calendar-icon" width="30" height="35" />
                        </span>
                        <span className="event-date-text">{formatDateRange(event.datepublication, event.datefin,localStorageChange.code)}</span>
                      </div>
                    </div>
                    <div className="link">
                      <a href={event.lien} className="event-link-icon" title={localStorageChange.code === englishLang.code ? "More info" : "Plus d'infos"}>
                        <i className="bi bi-box-arrow-up-right"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          {events.length > current * 6 && (
            <div className="load-more-button d-flex justify-content-center align-items-center">
              <button
                className="load-btn-blue charge-more"
                id="load-more-btn"
                onClick={() => setCurrent(current + 1)}
                disabled={loading}
              >
                {loading
                  ? (localStorageChange.code === englishLang.code ? 'Loading...' : 'Chargement...')
                  : (localStorageChange.code === englishLang.code ? 'Load more' : 'Charger plus')}
              </button>
            </div>
          )}
        </div>
      </section>
      <footer>
        <FooterSection />
      </footer>
    </>
  );
}
